import { BookingStatus } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';

export const BOOKING_STATUS_ICON: Record<BookingStatus, NoddiIconName> = {
  [BookingStatus.DRAFT]: 'Circle',
  [BookingStatus.CONFIRMED]: 'ShieldCheck',
  [BookingStatus.ASSIGNED_TO_ROUTE]: 'Route',
  [BookingStatus.CANCELLED]: 'XCircle',
  [BookingStatus.COMPLETED]: 'CircleCheck',
  [BookingStatus.DRAFT_PAY_BEFORE]: 'HandCoins',
  [BookingStatus.ADMIN_CREATED_PAYMENT_REQUESTED]: 'CircleDollarSign'
};
